import { render } from "./H5Order.vue?vue&type=template&id=0d6d857b"
import script from "./H5Order.vue?vue&type=script&lang=js"
export * from "./H5Order.vue?vue&type=script&lang=js"

import "./H5Order.vue?vue&type=style&index=0&id=0d6d857b&lang=css"

import exportComponent from "D:\\fxwl\\wx-wl_full\\wx-wl_full\\fxwl\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__